import { render } from "./DeliveryManagement.vue?vue&type=template&id=d7483992&scoped=true"
import script from "./DeliveryManagement.vue?vue&type=script&lang=js"
export * from "./DeliveryManagement.vue?vue&type=script&lang=js"

import "./DeliveryManagement.vue?vue&type=style&index=0&id=d7483992&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d7483992"

export default script